export default __webpack_public_path__ + "b560ecb4a602a787e69254f9279fba6f.svg";